module.exports = __webpack_public_path__ + "img/gold-card.c8e177e3.png";